import React from 'react';
import { useNavigation } from '../contexts/NavigationContext';
import { COURSE_UNITS_DATA } from '../data/unitsData'; 
import { FaArrowRight, FaBookOpen, FaArrowLeft } from 'react-icons/fa';

// MAPPING: Converts raw filenames to nice display titles
export const LESSON_TITLES = {
    "AdventureKidsLesson1.js": "Morning Activities & Holidays",
    "AdventureKidsLesson2.js": "Space Adventures",
    "AdventureKidsLesson3.js": "Adventure Conversations",
    "BeginnerKidsLesson1.js": "Hello World!",
    "BeginnerKidsLesson2.js": "Art & Numbers",
    "BeginnerKidsLesson3.js": "The Camping Trip",
    "BeginnerKidsLesson4.js": "Home & Family Stories",
    "BeginnerKidsLesson5.js": "A Trip to the Mall",
    "BeginnerKidsLesson6.js": "Let's Eat! Roleplay",
    "BeginnerKidsLesson7.js": "Weather & Seasons",
    "BeginnerKidsLesson8.js": "My Day",
    "BeginnerKidsLesson9.js": "Clothes & Fashion",
    "BeginnerKidsLesson10.js": "Home & Family",
    "BeginnerKidsLesson11.js": "Weather Reporter",
    "BeginnerKidsLesson12.js": "Forest Camping",
    "BeginnerKidsLesson13.js": "Travel & Transport",
    "BeginnerKidsLesson14.js": "The Toy Shop",
    "BeginnerKidsLesson15.js": "Level 1 Capstone"
};

const UnitLessonsPage = () => {
    const { navigateTo, currentPageData } = useNavigation();

    const { courseId, unitId, unitTitle, courseTitle } = currentPageData;
    const courseData = COURSE_UNITS_DATA[courseId];
    const unitData = courseData?.units.find(u => u.unitId === unitId);
    const lessonFileNames = unitData?.lessons || []; 
    
    const getLessonTitle = (fileName, index) => {
        if (LESSON_TITLES[fileName]) {
            return `Lesson ${index + 1}: ${LESSON_TITLES[fileName]}`;
        }
        const cleanName = fileName.replace('.js', '').replace(/([A-Z])/g, ' $1').trim();
        return `Lesson ${index + 1}: ${cleanName}`;
    };

    if (!courseId || !unitId) {
        return (
            <div className="container mx-auto p-10 text-center">
                <button onClick={() => navigateTo('eslCourses')} className="bg-blue-600 text-white py-2 px-6 rounded-lg">Go to Lessons</button>
            </div>
        );
    }

    const handleLessonSelect = (lessonFileName) => {
        const lessonPath = lessonFileName.replace('.js', '');
        navigateTo(`lessons/${lessonPath}`, { 
            ...currentPageData, 
            lessonFileName 
        });
    };

    return (
        <div className="container mx-auto p-6 md:p-10">
            <div className="mb-6">
                <button 
                    onClick={() => navigateTo('units', { courseId, title: courseTitle })} 
                    className="flex items-center text-gray-600 hover:text-blue-600 font-bold transition-colors"
                >
                    <FaArrowLeft className="mr-2" /> Back to {courseTitle}
                </button>
            </div>

            <header className="mb-8 pb-4 border-b border-gray-200">
                <p className="text-sm font-semibold text-gray-500 uppercase tracking-wider">{courseTitle}</p>
                <h1 className="text-4xl font-extrabold text-gray-800">{unitTitle}</h1>
            </header>

            <div className="space-y-4">
                {lessonFileNames.length > 0 ? (
                    lessonFileNames.map((lessonFileName, index) => (
                        <div
                            key={index}
                            className="flex justify-between items-center bg-white p-5 rounded-xl shadow-md cursor-pointer border-l-4 border-purple-500 hover:shadow-lg transition-transform hover:scale-[1.01]"
                            onClick={() => handleLessonSelect(lessonFileName)}
                        >
                            <div className="flex items-center gap-4">
                                <FaBookOpen className="text-purple-500 text-3xl" />
                                <div>
                                    <h3 className="text-xl font-bold text-gray-800">
                                        {getLessonTitle(lessonFileName, index)}
                                    </h3>
                                </div>
                            </div>
                            <FaArrowRight className="text-purple-500" />
                        </div>
                    ))
                ) : (
                    <div className="text-center p-10 text-gray-500">No lessons found for this unit.</div>
                )}
            </div>
        </div>
    );
};

export default UnitLessonsPage;